import React, { useContext } from 'react'
import { FormContext } from '../../FormContext'
  
const StepSuccess: React.FC = () => {
    const context = useContext(FormContext);
  
    if (!context) {
      throw new Error("StepSuccess must be used within a FormContextProvider");
    }
  
    const { 
        name,
        handleValidationIntroduction,
    } = context;

    return (
        <div className='px-4 mt-2 my-auto'>
            <form action="" onSubmit={handleValidationIntroduction} className=''>
                <div className='mb-4 space-y-6'>
                    <h3 className='text-black text-3xl font-bold text-center'>That's everything ...</h3>
                    <h3 className='text-black text-md font-base text-center'>We’re excited that you’ve taken the first step towards enhancing your team’s skills through our corporate training program.</h3>
                    <div className='bg-slate-100 rounded-lg p-6 flex flex-col'>
                        <p className='text-slate-900 text-sm'>Our team will reach out to you shortly to discuss the details and ensure we tailor the training to your company’s unique needs. Stay tuned for more information!</p>
                    </div>
                </div>
            </form>
        </div>
    );
}

export default StepSuccess